<div class="scope-container">
<table class="form-table" [formGroup]="scopeForm">
    <tbody>
        <tr>
            <td>
                <label for="energyProcesses">Energy & processes</label>
            </td>
            <td>
                <input type="text" class="form-control" id="energyProcesses" formControlName="energyProcesses" [ngClass]="{'is-invalid': (energyProcessesControl.touched || energyProcessesControl.dirty) && !energyProcessesControl.valid, 'is-valid': energyProcessesControl.valid}" />
            </td>
        </tr>
        <tr>
            <td>
                <label for="procurement">Procurement</label>
            </td>
            <td>
                <input type="text" class="form-control" id="procurement" formControlName="procurement" [ngClass]="{'is-invalid': (procurementControl.touched || procurementControl.dirty) && !procurementControl.valid, 'is-valid': procurementControl.valid}" />
            </td>
        </tr>
        <tr>
            <td>
                <label for="transport">Transport</label>
            </td>
            <td>
                <input type="text" class="form-control" id="transport" formControlName="transport" [ngClass]="{'is-invalid': (transportControl.touched || transportControl.dirty) && !transportControl.valid, 'is-valid': transportControl.valid}" />
            </td>
        </tr>
        <tr>
            <td>
                <label for="wasteRecycling">Waste & recycling</label>
            </td>
            <td>
                <input type="text" class="form-control" id="wasteRecycling" formControlName="wasteRecycling" [ngClass]="{'is-invalid': (wasteRecyclingControl.touched || wasteRecyclingControl.dirty) && !wasteRecyclingControl.valid, 'is-valid': wasteRecyclingControl.valid}" />
            </td>
        </tr>
        <tr>
            <td>
                <label for="soldProducts">Sold products</label>
            </td>
            <td>
                <input type="text" class="form-control" id="soldProducts"   formControlName="soldProducts" [ngClass]="{'is-invalid': (soldProductsControl.touched || soldProductsControl.dirty) && !soldProductsControl.valid, 'is-valid': soldProductsControl.valid}" />
            </td>
        </tr>
        <tr>
            <td>
                <label for="total">Total</label>
            </td>
            <td>
                <input type="text" class="form-control" id="total" formControlName="total" [ngClass]="{'is-invalid': (totalControl.touched || totalControl.dirty) && !totalControl.valid, 'is-valid': totalControl.valid}" />
            </td>
        </tr>
    </tbody>
</table>
</div>
